export default __webpack_public_path__ + "static/char-s-54-en-112c034e44bf26a10482dfc8ee1c60d7.webp";